export default {
  namespaced: true,
  state: {
    drawer: true,
    defaultNavItems: [
      {
        name: 'common.navigation.my_profile',
        route: '/profile',
      },
      {
        name: 'common.navigation.my_recordings',
        route: '/videos',
      },
      {
        name: 'common.navigation.shared_with_me',
        route: '/shared-with-me',
        permission: ['beSharedWith', 'Video'],
        mode: 'disable',
      },
      {
        name: 'common.navigation.my_programs',
        route: '/programs',
        permission: ['read', 'Program'],
      },
      {
        name: 'common.navigation.my_sessions',
        route: '/sessions',
        permission: ['read', 'Session'],
        mode: 'hide',
      },
      {
        name: 'common.navigation.activities',
        route: '/activities',
        permission: ['view', 'Activity'],
        mode: 'hide',
      },
      {
        name: 'common.navigation.my_calendar',
        route: '/calendar',
        permission: ['read', 'Calendar'],
        mode: 'hide',
      },
      /*
      {
        name: 'Account settings',
        route: null, // add later
      },
      */
    ],
    navItems: [],
    navTitle: {
      title: null,
      route: null,
    },
    snackbar: {
      show: false,
      type: 'success',
      text: '',
      position: 'bottom',
    },
    download: {
      show: false,
      revealComplete: false,
      title: '',
      text: '',
    },
    contactSales: {
      show: false,
    },
    platformRequirements: {
      show: false,
    },
    adminViewAs: {
      programType: null,
      onboarded: null,
      hidden: false,
    },
    error: {
      message: 'error.default_message',
    },
  },
  getters: {
    getDrawer(state) {
      return state.drawer;
    },
    getDownloadDialog(state) {
      return state.download;
    },
    getSnackbar(state) {
      return state.snackbar;
    },
    getError(state) {
      return state.error;
    },
    getContactSales(state) {
      return state.contactSales;
    },
    getAdminViewAs(state) {
      return state.adminViewAs;
    },
  },
  actions: {
    setDownloadDialog(context, payload) {
      context.commit('SET_DOWNLOAD_DIALOG', payload);
    },
    setDrawer(context, drawer) {
      context.commit('SET_DRAWER', drawer);
    },
    toggleDrawer(context, drawer) {
      context.commit('TOGGLE_DRAWER', drawer);
    },
    setNavItems(context, items) {
      context.commit('SET_NAV_ITEMS', items);
    },
    setNavTitle(context, title) {
      context.commit('SET_NAV_TITLE', title);
    },
    resetNav({ commit, state }) {
      commit('SET_NAV_ITEMS', state.defaultNavItems);
      commit('SET_NAV_TITLE', {
        title: null,
        route: null,
      });
    },
    snackBar({ commit }, payload) {
      commit('SET_SNACKBAR', payload);
    },
    contactSales({ commit }, payload) {
      commit('SET_CONTACT_SALES', payload);
    },
    setAdminViewAs({ commit }, payload) {
      commit('SET_ADMIN_VIEW_AS', payload);
    },
  },
  mutations: {
    SET_DRAWER: (state, drawer) => {
      state.drawer = drawer;
    },
    SET_NAV_ITEMS: (state, items) => {
      state.navItems = items;
    },
    SET_NAV_TITLE: (state, title) => {
      state.navTitle = title;
    },
    TOGGLE_DRAWER: (state) => {
      state.drawer = !state.drawer;
    },
    SET_SNACKBAR(state, snackbar) {
      state.snackbar = snackbar;
    },
    SET_CONTACT_SALES(state, payload) {
      state.contactSales = payload;
    },
    SET_DOWNLOAD_DIALOG(state, payload) {
      state.download = payload;
    },
    SET_ADMIN_VIEW_AS(state, payload) {
      state.adminViewAs = { ...state.adminViewAs, ...payload };
    },
  },
};
